import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import Types from '../components/Types';
import CodeInfo from '../components/CodeInfo';
import ParamsTable from '../components/ParamsTable';
import ExampleItems from '../components/ExampleItems';

var PropertyItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PropertyItem, _React$Component);

  function PropertyItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PropertyItem.prototype;

  _proto.render = function render() {
    var data = this.props.data;
    var pid = data.pid,
        override = data.override,
        deprecated = data.deprecated,
        name = data.name,
        types = data.types,
        description = data.description,
        codeInfo = data.codeInfo,
        examples = data.examples,
        params = data.params;
    var properties = params.slice();
    properties.pop();
    return React.createElement("div", {
      id: pid,
      className: "definition-list"
    }, React.createElement("dl", null, React.createElement("dt", {
      className: "subsection-term"
    }, React.createElement("h4", {
      className: "title"
    }, deprecated ? React.createElement("span", {
      className: "signiture deprecated"
    }, "deprecated") : null, override ? React.createElement("span", {
      className: "signiture override"
    }, "override") : null, React.createElement("span", {
      className: "name"
    }, name, ": "), " ", React.createElement(Types, {
      data: types
    }), React.createElement(CodeInfo, {
      data: codeInfo
    }))), React.createElement("dd", {
      className: "subsection-description"
    }, React.createElement("p", {
      className: "description"
    }, description), React.createElement(ParamsTable, {
      properties: properties,
      isPropertyTitle: true
    }), React.createElement(ExampleItems, {
      items: examples
    }))));
  };

  return PropertyItem;
}(React.Component);

export default PropertyItem;